// extracted by mini-css-extract-plugin
export default {"headerLink":"Header_headerLink__3H7qa","headerLine":"Header_headerLine__-+FMB","selected":"Header_selected__w-9ml"};